import React from "react";
import { DEFAULT_PIC } from "./constants";
import { messagePreview, formatTime } from "./chatUtils";

// =====================================================
// USER LIST (sidebar)
// The conversation list: search box + one row per mutual-follower chat with
// avatar, presence dot, last-message preview, time and unread badge.
// Presentational; the container supplies data + the open handler.
// =====================================================

function UserRow({ user, active, online, onOpen }) {
  return (
    <div
      className={`chat-user ${active ? "active-chat" : ""}`}
      onClick={() => onOpen(user)}
    >
      <div style={{ position: "relative" }}>
        <img src={user.profilePic || DEFAULT_PIC} alt="" />
        {online && <span className="online-dot" />}
      </div>

      <div className="chat-user-info">
        <h4>{user.name}</h4>
        <p className="last-msg">
          {messagePreview(user.lastMessage) || "No messages"}
        </p>
      </div>

      <div className="chat-user-meta">
        <small>{formatTime(user.lastMessage?.createdAt)}</small>
        {user.unreadCount > 0 && (
          <span className="unread-badge">{user.unreadCount}</span>
        )}
      </div>
    </div>
  );
}

const MemoRow = React.memo(UserRow);

function UserList({
  users,
  loading,
  search,
  onSearch,
  selectedUserId,
  onlineUsers,
  onOpen,
}) {
  const filtered = users.filter((u) =>
    u.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <h2>💬 Chats</h2>

      <input
        className="chat-search"
        placeholder="Search users..."
        value={search}
        onChange={(e) => onSearch(e.target.value)}
      />

      {loading ? (
        <p className="loading-text">Loading...</p>
      ) : (
        filtered.map((u) => (
          <MemoRow
            key={u._id}
            user={u}
            active={selectedUserId === u._id}
            online={onlineUsers.includes(u._id)}
            onOpen={onOpen}
          />
        ))
      )}
    </>
  );
}

export default UserList;
